import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "product-page" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "product-page__image" }
const _hoisted_6 = ["alt", "src"]
const _hoisted_7 = { class: "product-page__content" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 0,
  class: "product-page__section"
}
const _hoisted_10 = { class: "product-page__section-title heading heading--3" }
const _hoisted_11 = {
  key: 0,
  class: "product-page__bottom"
}
const _hoisted_12 = { class: "container" }
const _hoisted_13 = { class: "product-page__row" }
const _hoisted_14 = { class: "product-page__name" }
const _hoisted_15 = { class: "product-page__prices" }
const _hoisted_16 = { class: "product-page__price product-page__price--actual" }
const _hoisted_17 = {
  key: 0,
  class: "product-page__price product-page__price--old"
}
const _hoisted_18 = { class: "product-page__weight" }
const _hoisted_19 = { class: "product-page__btns" }

import { ref, onMounted, computed } from 'vue';
import ProductsList from '@/components/ProductsList.vue';
import { Product } from '@/types/app';
import { useRoute, useRouter } from 'vue-router';
import useProductsStore from '@/store/products';
import AppLoader from '@/components/AppLoader.vue';
import helpers from '@/helpers';
import IconCross from '@/icons/icon-cross.vue';
import QuantityPanelV2 from '@/components/QuantityPanelV2.vue';
import AppBtn from '@/components/AppBtn.vue';
import useShoppingCartStore from '@/store/shopping-cart';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductPage',
  setup(__props) {

const productsStore = useProductsStore();
const shippingCartStore = useShoppingCartStore();
const router = useRouter();
const route = useRoute();
const productId = parseInt(route.params.productId as string, 10);
const product = ref<Product>();
const isLoadingProducts = ref(true);

const initProduct = async () => {
  isLoadingProducts.value = true;
  if (!productsStore.isProductsLoaded) {
    await productsStore.loadProducts();
  }
  isLoadingProducts.value = false;
  product.value = productsStore.getProduct(productId);
};

const inCartQuantity = computed<number>(() => (!product.value
  ? 0 : shippingCartStore.productQuantity(product.value!.productId)));

onMounted(() => {
  initProduct();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (isLoadingProducts.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(AppLoader)
          ]))
        : (!product.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('errorProductNotFound')), 1))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  alt: product.value.name,
                  src: product.value.images[0].full
                }, null, 8, _hoisted_6),
                _createElementVNode("button", {
                  class: "product-page__close-btn",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(router).back()), ["prevent"]))
                }, [
                  _createVNode(IconCross)
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "product-page__description",
                  innerHTML: product.value.description
                }, null, 8, _hoisted_8)
              ]),
              (product.value.related && product.value.related.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('buyWithThisProduct')), 1),
                    _createVNode(ProductsList, {
                      products: product.value.related
                    }, null, 8, ["products"])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
    ]),
    (product.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(product.value!.name), 1),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(helpers).formatCurrency(product.value.special || product.value.price)), 1),
                (product.value.special)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(helpers).formatCurrency(product.value.price)), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, _toDisplayString(product.value.weight) + _toDisplayString(product.value.weightUnitLabel), 1),
            _createElementVNode("div", _hoisted_19, [
              (product.value.quantity === 0)
                ? (_openBlock(), _createBlock(AppBtn, {
                    key: 0,
                    disabled: "",
                    class: "product-page__not-in-stock-btn"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('notInStock')), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (inCartQuantity.value > 0)
                      ? (_openBlock(), _createBlock(QuantityPanelV2, {
                          key: 0,
                          class: "product-page__quantity-panel",
                          "model-value": inCartQuantity.value,
                          max: product.value.quantity,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = quantity => _unref(shippingCartStore)
                .changeProductQuantity([{ product: product.value!, quantity }]))
                        }, null, 8, ["model-value", "max"]))
                      : _createCommentVNode("", true),
                    (inCartQuantity.value > 0)
                      ? (_openBlock(), _createBlock(AppBtn, {
                          key: 1,
                          class: "product-page__add-more-btn",
                          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(router).push({ name: 'catalog' })), ["prevent"]))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('toAddMoreProduct')), 1)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(AppBtn, {
                          key: 2,
                          class: "product-page__add-to-cart-btn",
                          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_unref(shippingCartStore).addProduct(product.value)), ["prevent"]))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('toAddToCart')), 1)
                          ]),
                          _: 1
                        }))
                  ], 64))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})